var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.667 19H3.66695C2.98414 19 2.32733 18.7382 1.83183 18.2684C1.33941 17.8015 1.04358 17.1646 1.00429 16.4875L1 16.3202V3.667C1 2.24616 2.11102 1.08465 3.51221 1.0043L3.67982 1H16.333C17.7538 1 18.9153 2.11101 18.9957 3.51219L19 3.67983V16.333C19 17.7538 17.889 18.9153 16.4878 18.9957L16.3202 19H3.667ZM14.4141 6.58593L14.414 6.58579C14.0389 6.21085 13.5303 6.00021 13 6.00021C12.4697 6.00021 11.9611 6.21085 11.586 6.58579L8.99983 9.17117L8.41383 8.58562L8.39201 8.56382L8.36889 8.5434L8.27489 8.4604L8.25047 8.43883L8.22469 8.41891C7.82271 8.10808 7.31749 7.96192 6.81164 8.01011C6.3058 8.0583 5.83726 8.29722 5.50119 8.67835C5.16512 9.05948 4.98673 9.55424 5.00224 10.0621C5.01775 10.57 5.226 11.053 5.58469 11.4129L5.58589 11.4141L7.58589 13.4141L7.60784 13.4361L7.63111 13.4566L7.72511 13.5396L7.74895 13.5607L7.77407 13.5801C8.15888 13.8786 8.63939 14.0265 9.12543 13.9959C9.61149 13.9654 10.0697 13.7585 10.4141 13.4141L10.4141 13.4141L14.4141 9.41411L14.4361 9.39216L14.4566 9.36889L14.5396 9.27489L14.5607 9.25105L14.5801 9.22593C14.8786 8.84112 15.0265 8.36061 14.9959 7.87457C14.9654 7.38851 14.7585 6.93031 14.4141 6.58593Z",
    fill: "#362FD8",
    stroke: "#362FD8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector-2.f49943f5b9163682c6804d9dda769e89.svg";
export { ForwardRef as ReactComponent };